export const demoTooltipTable = {
    'all-all': 'All',
    'income-low/moderate': 'Low/Mod. Income',
    'income-middle/upper': 'Mid./Upper Income',
    'riskscore-prime': 'Prime',
    'riskscore-nonprime': 'Nonprime',
    'age-18-34': '18-34',
    'age-35-54': '35-54',
    'age-55-84': '55-84',
    'race/ethnicity-Majority People of Color': 'Maj. POC',
    'race/ethnicity-Majority Non-Hispanic White': 'Maj. White',
    'race/ethnicity (detailed)-Majority Black': 'Maj. Black',
    'race/ethnicity (detailed)-Majority Native American': 'Maj. Nat. Amer.',
    'race/ethnicity (detailed)-Majority Hispanic or Latino': 'Maj. Hisp. or Lat.',
    'race/ethnicity (detailed)-Majority Asian or Pacific Islander': 'Maj. Asian or PI'
};
